// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-design {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important; }\n  .modal-design .modal-content .modal-header {\n    border-bottom-color: #D9D9D9; }\n    .modal-design .modal-content .modal-header .modal-title {\n      font-size: 24px; }\n", ""]);
// Exports
module.exports = exports;
